import React from "react";
import { TypeOf } from 'zod';
import {Save} from "@mui/icons-material";
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {Button, Stack, Box, Badge,} from "@mui/material";
import useEntity from "../../../hooks/useCordwoodHistory";
import {PrimaryCordwoodHistory} from "../../../types/models/CordwoodHistory";
import {useGetCordwoodHistoryQuery} from "../../../apis/CordwoodHistory.api";
import CordwoodHistoryUpdateForm, {formSchema, initialFormStateFn} from "../../../components/cordwoodHistory/CordwoodHistoryForm/CordwoodHistoryUpdateForm";
import { Trans } from "@lingui/react/macro";

export type FormInput = TypeOf<typeof formSchema>;

const CordwoodHistoryUpdateFormProvider = ({ id, initialFormState, cancelButton = undefined, redirectPath = undefined, successAction = undefined }) => {

    const primary = PrimaryCordwoodHistory.fromPath(id);
    const { data, isLoading } = useGetCordwoodHistoryQuery(primary)

    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: initialFormState(data)
    });
    const {  } = useEntity();

    const {
        watch,
        reset,
        handleSubmit,
        formState: { isSubmitSuccessful, errors, },
    } = methods;

    React.useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data, reset]);

    

    return (
        <>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    
                    noValidate
                >

                    <CordwoodHistoryUpdateForm watch={watch}/>

                    <Stack direction="row" justifyContent="end" spacing={1} padding={5}>

                        { cancelButton }

                        
                    </Stack>
                </Box>
            </FormProvider>
        </>
    )
}

export default CordwoodHistoryUpdateFormProvider
